export default "__VITE_ASSET__Bo9ia806__"